/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-12-05 11:39:10
 *
 *******************************************************/
// @flow


import React, { Component } from 'react';
import _ from 'lodash';
import { Thumbnail, Button, Link, Icon } from '@shopify/polaris';
import { DeleteMinor, DragHandleMinor, ExternalSmallMinor } from '@shopify/polaris-icons';
import { withI18n } from '@shopify/react-i18n';
import noProductImage from 'src/assets/images/product/no-product-image.png';
import { optimizeImage } from 'src/helpers';
import { getShop } from 'src/helpers';

class IncludeProductItem extends Component {
  render() {
    const shop = getShop();
    const { dragHandleProps, product } = this.props;
    const { images } = product;
    let image = _.isEmpty(images)
      ? noProductImage
      : optimizeImage(images[Object.keys(images)[0]], '40x40');
    const url = `https://${shop}/admin/products/${product.id}`;

    return (
      <div className="ProductsList__item">
        <div
          className="ProductsList__item-draggable"
          {...dragHandleProps}>
          <Icon source={DragHandleMinor} color="subdued" />
        </div>

        <div className="ProductsList__item-thumbnail">
          <Thumbnail source={image} size="small" />
        </div>
        <div className="ProductsList__item-title">
          <Link removeUnderline external url={url}>
            {product?.title}
            <Icon source={ExternalSmallMinor} color={'interactive'}></Icon>
          </Link>
          <div className="ProductsList__item-action">
            <Button size="slim" icon={DeleteMinor} plain onClick={this.handleRemove} />
          </div>
        </div>
      </div>
    );
  }

  handleRemove = () => {
    const { product, onRemove } = this.props;
    onRemove('includeProducts', product);
  };
}

export default withI18n()(IncludeProductItem);
